import { useTranslation } from 'react-i18next'
import { UpcomingPayroll } from '../../../../../redux/types'
import { PayrollHeader, StatusMessage, ImportFilesForPayday, PayrollActions } from '..'

interface OverdueContentProps {
  upcomingPayroll: UpcomingPayroll
}

const OverdueContent = ({
  upcomingPayroll
}: OverdueContentProps) => {
  const { t } = useTranslation(['common', 'payrolls'])

  return (
    <>
      <PayrollHeader
        labelText={t('overduePayday', { ns: 'payrolls' })}
        paymentDate={upcomingPayroll.paymentDate}
      />
      <StatusMessage
        message={t('overdueTitle', { ns: 'payrolls' })}
        subMessage={t('overdueSubtitle', { ns: 'payrolls' })}
        latestSubmitDateIntro={t('uploadFileNowIntro', { ns: 'payrolls' })}
        latestSubmitDate={t('now', { ns: 'payrolls' })}
      />
      <ImportFilesForPayday
        upcomingPayroll={upcomingPayroll}
      />
      <PayrollActions
        upcomingPayroll={upcomingPayroll}
      />
    </>
  )
}

export default OverdueContent
